import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

const PreviouslyAssignedSkeleton = () => (
	<Stack spacing={1} mt={2}>
		<Grid container spacing={3} alignItems="stretch" pr={2}>
			<Grid item xs={12} sm={6} md={4}>
				<Skeleton variant="rounded" height={250} />
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<Skeleton variant="rounded" height={250} />
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<Skeleton variant="rounded" height={250} />
			</Grid>
		</Grid>
	</Stack>
);

export default PreviouslyAssignedSkeleton;
